import { render, staticRenderFns } from "./StickyDiv.vue?vue&type=template&id=53bdc35f&"
import script from "./StickyDiv.vue?vue&type=script&lang=js&"
export * from "./StickyDiv.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports